import EditorImg from 'lowcode/components/EditorImg';
import styles from './index.module.scss';

export default function CardD() {
    return (
        <div className={styles.comp}>
            <div className="comp-in">
                <div className="comp-title">Anxiety from rising TOU electricity price gaps</div>
                <div className="comp-desc">
                The growing TOU price difference is forcing users to manually devise and track seasonal strategies for cost savings, a cumbersome process. This fear of high peak prices discourages electricity use, leading to life inconveniences and heightened anxiety about energy consumption.
                </div>
                <div className="comp-box">
                    <div className="comp-side-msg">
                        <div className="comp-item">
                            <div className="comp-item-title">
                                <img className="comp-item-icon" src="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1716255685310/Tou.png" />
                                Rising TOU price difference
                            </div>
                            <div className="comp-item-desc">Rising TOU price difference</div>
                        </div>
                        <div className="comp-item">
                            <div className="comp-item-title">
                                <img className="comp-item-icon" src="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1716255735669/t11.png" />
                                Constantly tracking data
                            </div>
                            <div className="comp-item-desc">It is very cumbersome to make their own money-saving strategies.</div>
                        </div>
                        <div className="comp-item">
                            <div className="comp-item-title">
                                <img className="comp-item-icon" src="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1716255782573/t12.png" />
                                Electricity anxiety
                            </div>
                            <div className="comp-item-desc">causing inconvenience to life and causing anxiety over electricity use</div>
                        </div>
                    </div>
                    <div className="comp-side-img">
                        <EditorImg pc="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1716799325605/aaa01.jpg" h5="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1716799381416/aaa02.jpg" />
                    </div>
                </div>
            </div>
        </div>
    );
}
